import { useIntl } from 'react-intl';

import { config } from '@/config/config';
import { useIsAdmin } from '@/modules/auth/hooks';
import { AddVaultButton, ManageVaults, VaultFormModal } from '@/modules/vaults/settings';

import { SettingsDetailLayout } from '../SettingsDetailLayout';

// Reachable by a vault editor without the admin role: editing and deleting are vault-role rights.
// Creating a team vault is not, and neither is the settings page the layout leads back to.
export const VaultsSettings = () => {
    const { formatMessage } = useIntl();
    const isAdmin = useIsAdmin();

    return (
        <SettingsDetailLayout
            title={formatMessage({ id: 'settings.vaults.title' })}
            divider={false}
            action={isAdmin ? <AddVaultButton /> : undefined}
            backTo={isAdmin ? config.routes.settings : config.routes.secrets}
        >
            <ManageVaults />
            {/* Mounted once per page and opened through the modal registry — by the header action here, and
                from P6 by the table's Edit row action. */}
            <VaultFormModal />
        </SettingsDetailLayout>
    );
};
